const setWrappedDisplayName = (name) => (WrappedComponent) => {
	WrappedComponent.displayName = `${name}(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
	return WrappedComponent;
};

export const overwriteDisplayName = (name) => (WrappedComponent) => {
	WrappedComponent.displayName = name;
	return WrappedComponent;
};

export default setWrappedDisplayName;
